<template>
	<footer class="footer">
		<!-- 底部内容 -->
		<!-- <div class="jc_sa">
			<div class="footer_list">
				<div v-for="item in list1" :key="item.id">{{item.name}}</div>
			</div>
			<div class="footer_list">
				<div v-for="item in list2" :key="item.id">{{item.name}}</div>
			</div>
			<div class="footer_list">
				<div v-for="item in list3" :key="item.id">{{item.name}}</div>
			</div>
			<div class="footer_msg">
				<div class="msg">
					<a href="https://beian.miit.gov.cn/" target="_blank">{{record_number}}</a>
				</div>
				<div style="margin-top: 13px;font-size: 11px;color: white;">Subscribe to our Newsletter</div> -->
				<!-- <div class="email">
					<el-input placeholder="Enter your Email" type="text"
						style="border-radius: 5.36px;background: rgba(128, 128, 128, 1);" border="none"
						v-model="input3">
						<template #append>
							<div class="templateStyle">
								Subscribe
							</div>
						</template>
					</el-input>
				</div> -->
			<!-- </div>
		</div> -->
	</footer>
</template>

<script>
	export default {
		name: 'PageFooter',
		data() {
			return {
				input3: '',
				list1: [{
						id: 0,
						url: '',
						name: 'Company'
					},
					{
						id: 1,
						url: '',
						name: 'About Us'
					},
					{
						id: 2,
						url: '',
						name: 'Why Choose us'
					},
					{
						id: 3,
						url: '',
						name: 'Pricing'
					},
					{
						id: 4,
						url: '',
						name: 'Testimonial'
					},
				],
				list2: [{
					id: 0,
					url: '',
					name: 'Resources'
				}, {
					id: 1,
					url: '',
					name: 'Privacy Policy'
				}, {
					id: 2,
					url: '',
					name: 'Terms and Condition'
				}, {
					id: 3,
					url: '',
					name: 'Blog'
				}, {
					id: 4,
					url: '',
					name: 'Contact Us'
				}],
				list3: [{
					id: 0,
					url: '',
					name: 'Product'
				}, {
					id: 1,
					url: '',
					name: 'Project managment'
				}, {
					id: 2,
					url: '',
					name: 'Time tracker'
				}, {
					id: 3,
					url: '',
					name: 'Time schedule'
				}, {
					id: 4,
					url: '',
					name: 'Lead generate'
				}, {
					id: 5,
					url: '',
					name: 'Remote Collaboration'
				}],
				record_number: ''
			}
		},
		methods: {

		},
		mounted() {
			this.record_number = localStorage.getItem('record_number')
		}
	}
</script>

<style scoped>
	.footer {
		background-color: rgba(12, 30, 51, 1);
		color: white;
		/* text-align: center; */
		padding: 20px 73px 10px 73px;
		box-sizing: border-box;
		/* 或者使用 absolute 根据需求 */
		width: 100%;

	}

	.jc_sa {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.footer_list {
		div {
			font-size: 12.06px;
			font-weight: 600;
			letter-spacing: 0px;
			line-height: 18.08px;
			color: rgba(255, 255, 255, 1);
			margin-bottom: 6px;
		}
	}

	.msg a {
		color: rgba(255, 255, 255, 1);
		font-weight: 700;
		font-size: 20px;
		cursor: pointer;
		text-decoration: none;
	}

	.email {
		border-radius: 5.36px;
		background: rgba(128, 128, 128, 1);
		margin-top: 12px;
	}

	.templateStyle {
		width: 100.91px;
		height: 37.51px;
		border-radius: 8.04px;
		background: rgba(255, 255, 255, 1);
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		padding: 10px;
		/* padding: 10.72px 16.79px 10.72px 16.79px; */
		box-sizing: border-box;
	}

	.tips {
		font-size: 8.04px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 12.06px;
		/* color: rgba(255, 255, 255, 1); */
		background-color: none;
	}
</style>